import { capitalize } from "@helper/stringTransform";
import type { GADataProps } from "@typings/GA";
import type { MetaTagsProps } from "@typings/MetaTags";
import type { PageMetaDataValues } from "@typings/PageMetaData";

export default function VideoMetaData(section: string): PageMetaDataValues {
  const gaData: GADataProps = {
    level2: section,
    title: `${capitalize(section)}_Index`,
    section: section,
    contentcat: "1",
    contenttype: "listing",
  };

  const metaTags: MetaTagsProps = {
    title: "Videos, Berita - Beritaharian.sg",
    description:
      "Berita Harian Singapura - Tonton video mengenai Singapura, Asia dan dunia.",
    slug: `/${section}`,
  };

  return {
    gaData,
    metaTags,
  };
}
